// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customerHeaderContainer[data-v-55b20e8a] {\n  border-bottom: 1px solid #e0e0e0;\n}\n.customerBodyItem[data-v-55b20e8a] {\n  flex: 1 1 calc(50% - 10px);\n  box-sizing: border-box;\n}\n.customerBodyItem .btn[data-v-55b20e8a] {\n  padding-left: 10px;\n  padding-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
